import React, { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";

// Public pages
const About = lazy(() => import("./pages/About"));
const Events = lazy(() => import("./pages/Events"));
const Contact = lazy(() => import("./pages/Contact"));
const Donate = lazy(() => import("./pages/Donate"));
const Team = lazy(() => import("./pages/Team"));
const Construction = lazy(() => import("./pages/Construction"));

// Admin pages
const AdminLogin = lazy(() => import("./admin/AdminLogin"));
const AdminResetPassword = lazy(() => import("./admin/AdminResetPassword"));
const ProtectedRoute = lazy(() => import("./admin/ProtectedRoute"));
const AdminLayout = lazy(() => import("./admin/AdminLayout"));
const DashboardPage = lazy(() => import("./admin/pages/DashboardPage"));
const SiteSettingsPage = lazy(() => import("./admin/pages/SiteSettingsPage"));
const HeroPage = lazy(() => import("./admin/pages/HeroPage"));
const AboutPage = lazy(() => import("./admin/pages/AboutPage"));
const ImpactStatsPage = lazy(() => import("./admin/pages/ImpactStatsPage"));
const GalleryPage = lazy(() => import("./admin/pages/GalleryPage"));
const TeamPage = lazy(() => import("./admin/pages/TeamPage"));
const ConstructionPage = lazy(() => import("./admin/pages/ConstructionPage"));
const DonatePage = lazy(() => import("./admin/pages/DonatePage"));
const ContactPage = lazy(() => import("./admin/pages/ContactPage"));
const TestimonialsPage = lazy(() => import("./admin/pages/TestimonialsPage"));
const NavigationPage = lazy(() => import("./admin/pages/NavigationPage"));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Events />} />
          <Route path="/Gallery" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/team" element={<Team />} />
          <Route path="/Team" element={<Team />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/donate" element={<Donate />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="settings" element={<SiteSettingsPage />} />
            <Route path="hero" element={<HeroPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="impact" element={<ImpactStatsPage />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="construction" element={<ConstructionPage />} />
            <Route path="donate" element={<DonatePage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="testimonials" element={<TestimonialsPage />} />
            <Route path="menus" element={<NavigationPage />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
